// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"602f6c72","952":"0124eb58"}[chunkId] + ".chunk.js";
};